import { useNavigate } from "react-router-dom";
import styles from "../../styles/Blog/Blog.module.css";
import formatDate from "../../Utils/FormatDate";
import { base_url } from "../../ReuableFunctions/Blogs";

const Blog = ({ data }) => {
  const navigate = useNavigate();
  // const direction = type === "HORIZONTAL" ? "column" : "row";
  function handleRedirect(blogId){
    console.log("Rediecting to the blog", blogId);
    navigate(`/blog/${blogId}`)
  }
  return (
    <div className={styles.blogContainer} onClick={()=>handleRedirect(data?.["blogId"])} style={{cursor:"pointer"}}>
      <div
        className={styles.blogInnerContainer}
        // style={{ flexDirection: direction }}
      >
        <div className={styles.blogLeftContainer}>
          <div className={styles.blogLeftImage}>
            <img src={`${base_url}/blog-image/${data?.["blogId"]}`} className={styles.Image} alt="blog-image" loading="lazy" />
          </div>
        </div>
        <div className={styles.blogRightContainer}>
          <div className={styles.blogRightTagsContainer}>
            {data["blogCategory"] !== "" && data["blogCategory"].split(",").map((category, index)=>(
              <span className={styles.blogRightTag} key={index}>{category}</span>
            ))}
          </div>
          <div className={styles.blogRightTitle}>
            {data["blogTitle"] || "Title Not Available"}
          </div>
          <div className={styles.blogRightInfo}>
            <div className={styles.blogRightImageAndNameContainer}>
              <div className={styles.blogRightImage}></div>
              <div className={styles.blogRightName}>Mohit Valecha</div>
            </div>
            <div className={styles.blogRightDate}>
              <img src="/calendar.svg" alt="calendar" loading="lazy" />
              <span>{formatDate(data?.["createdDate"])}</span>
            </div>
            {/* <div className={styles.blogRightRead}>
              <img src="/time.svg" alt="calendar" />
              <span>3 min read</span>
            </div> */}
          </div>
          <div className={styles.blogRightDesc}>
            {data["blogDescription"] || "Description Not Available"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;

/*
    BLOG WILL TAKE TWO PROPS
    1 -> BLOG DATA
    2 -> TYPE OF BLOG(VERTICAL OR HORIZONTAL)
*/
